import merge from 'lodash/merge'

export default function baseButtonStyles({
  icon,
  iconAlignment,
  variant,
  color,
  background,
  border,
  fullWidth
}) {
  
  let jss = {
    outline: 'none',
    textAlign: 'center',
    display: 'inline-block',

    '& .subtext': {
      fontSize: '0.8em',
      display: 'block',
      width: '100%',
    }
  }

  if(fullWidth) {
    merge(jss, {
      width: '100%'
    })
  }

  if(color) {
    merge(jss, {
      color: color
    })
  }
  
  if(icon) {

    merge(jss, {
      '& .text': {
        display: 'flex',      
        justifyContent: 'center',      
        alignItems: 'center',      
      }
    })

    merge(jss, {
      '& .c-icon': {
        fontSize: '1.2em',  
      }
    })
    
    if(iconAlignment === 'start') {

      merge(jss, {
        '& .text': {
          flexDirection: 'row-reverse',
        }
      })   

      merge(jss, {
        '& .c-icon': {
          marginRight: '0.3em'
        }
      })    

    }

    if(iconAlignment === 'end') {

      merge(jss, {
        '& .c-icon': {
          marginLeft: '0.3em'
        }
      })       
    }

  }
  
  switch(variant) {

    case 'solid': 

      merge(jss, {
        borderRadius: "var(--themeShape)"
      })

      if(background) {
        merge(jss, {
          backgroundColor: background   
        })
      }

      break

    case 'outlined':

      merge(jss, {
        borderRadius: "var(--themeShape)"  
      })   

      if(border) {
        merge(jss, 
          {
            borderColor: border,
            borderWidth: 'var(--themeBorderThickness)'
          })
      }
      break
  }

  return jss
}
